export default __webpack_public_path__ + "static/media/secure.be0841e4.png";